

import React from "react";
import { Layout } from "antd";

import { Fields } from "./Fields.js";
import { FieldSettings } from "./FieldSettings";

const { Content, Sider } = Layout;
export const FieldBaseView = () => {
  return (
    <Layout>
      <Content>
        <Layout style={{ background: "#fff" }}>
          <Sider
            width={550}
            
             style={{ background: "#fff", paddingLeft: "20px", width: "30%" }}
          >
            <div className="ms-Grid" dir="ltr">
              <div className="ms-Grid-row ">
                <div className="ms-Grid-col ms-sm12">
                  {" "}
                  <Fields/>
                </div>
              </div>
            </div>
          </Sider>
          <Content>
         <FieldSettings/>
          </Content>
        </Layout>
      </Content>
    </Layout>
  );
};

